const numberFormatter = new Intl.NumberFormat('en-US');
const relativeFormatter = new Intl.RelativeTimeFormat('en', { 'numeric': 'auto' });
export const formatNumber = (value) => numberFormatter.format(value);
export const formatIdentifier = (value) => value
    .replace(/[-_.]+/g, ' ')
    .replace(/\b\w/g, character => character.toUpperCase());
export const formatTimestamp = (value) => new Date(value).toLocaleString([], {
    'month': 'short',
    'day': 'numeric',
    'hour': 'numeric',
    'minute': '2-digit',
});
export const formatDate = (value) => new Date(value).toLocaleDateString([], {
    'month': 'short',
    'day': 'numeric',
    'year': 'numeric',
});
export const timeAgo = (value) => {
    const elapsed = new Date(value).valueOf() - Date.now();
    const minutes = Math.round(elapsed / 60_000);
    if (Math.abs(minutes) < 60)
        return relativeFormatter.format(minutes, 'minute');
    const hours = Math.round(minutes / 60);
    if (Math.abs(hours) < 24)
        return relativeFormatter.format(hours, 'hour');
    return relativeFormatter.format(Math.round(hours / 24), 'day');
};
